export * from './bridge.config';
